export type DeaneryOrganization = "Not Applicable" | "ICYM" | "YCS" | "ICYM-YCS";
export type DeaneryDesignationType = "Director" | "President" | "Others";

export type DeaneryMember = {
  docId?: string;
  deanery: string;
  name: string;
  designation: string;
  designationType?: DeaneryDesignationType;
  designationDetail?: string;
  place?: string;
  img?: string;
  organization: DeaneryOrganization;
  rank: number;
};

export const DEANERY_OPTIONS = [
  "Karkala Deanery",
  "Kundapur Deanery",
  "Udupi Deanery",
  "Kallianpur Deanery",
  "Shirva Deanery",
];

export const ORGANIZATION_OPTIONS: DeaneryOrganization[] = [
  "Not Applicable",
  "ICYM",
  "YCS",
  "ICYM-YCS",
];

export const DESIGNATION_TYPE_OPTIONS: DeaneryDesignationType[] = [
  "Director",
  "President",
  "Others",
];

export function getDeaneryDesignationPriority(member: Partial<DeaneryMember>) {
  const designationType = member.designationType;
  const organization = member.organization;
  const designation = (member.designation || "").toLowerCase();

  if (designationType === "Director" || designation.includes("director")) {
    if (organization === "ICYM-YCS" || designation.includes("icym-ycs")) {
      return 1;
    }

    if (organization === "ICYM" || (designation.includes("icym") && !designation.includes("ycs"))) {
      return 2;
    }

    if (organization === "YCS" || designation.includes("ycs")) {
      return 3;
    }

    return 4;
  }

  if (designationType === "President" || designation.includes("president")) {
    if (organization === "ICYM") {
      return 5;
    }

    if (organization === "YCS") {
      return 6;
    }

    return 7;
  }

  return 8;
}

export function buildDeaneryDesignation(
  organization: DeaneryOrganization,
  designationType: DeaneryDesignationType,
  designationDetail?: string,
) {
  if (designationType === "Others") {
    return designationDetail?.trim() || "Others";
  }

  if (organization === "Not Applicable") {
    return designationType;
  }

  return `${organization} ${designationType}`;
}

export const defaultDeaneryMembers: DeaneryMember[] = [
  {
    deanery: "Karkala Deanery",
    name: "Rev. Fr Avinash Lesly Pais",
    designation: "ICYM-YCS Director",
    img: "/images/directors/icym_ycs_karkala.jpeg",
    organization: "ICYM-YCS",
    rank: 1,
  },
  {
    deanery: "Karkala Deanery",
    name: "Jeevan Mascarenhas",
    designation: "ICYM President",
    place: "Attur",
    img: "/images/dexco/jeevan.jpeg",
    organization: "ICYM",
    rank: 2,
  },
  {
    deanery: "Karkala Deanery",
    name: "Jayden Coelho",
    designation: "YCS President",
    place: "Attur",
    img: "/images/ycsDexco/jayden.jpeg",
    organization: "YCS",
    rank: 3,
  },
  {
    deanery: "Kundapur Deanery",
    name: "Rev. Fr Roy Lobo",
    designation: "ICYM-YCS Director",
    img: "/images/directors/kundapur_icym_director.jpg",
    organization: "ICYM-YCS",
    rank: 1,
  },
  {
    deanery: "Kundapur Deanery",
    name: "Elson Ashish Dsouza",
    designation: "ICYM President",
    place: "Byndoor",
    img: "/images/dexco/elson.png",
    organization: "ICYM",
    rank: 2,
  },
  {
    deanery: "Kundapur Deanery",
    name: "Priyanka Dalmeida",
    designation: "YCS President",
    place: "Padukone",
    img: "/images/ycsDexco/priyanka.jpeg",
    organization: "YCS",
    rank: 3,
  },
  {
    deanery: "Udupi Deanery",
    name: "Rev. Fr Rajesh Pasanna",
    designation: "ICYM-YCS Director",
    img: "/images/directors/icym_udupi.jpg",
    organization: "ICYM-YCS",
    rank: 1,
  },
  {
    deanery: "Udupi Deanery",
    name: "Clarilda",
    designation: "ICYM President",
    place: "Udupi",
    img: "/images/dexco/clarilda.png",
    organization: "ICYM",
    rank: 2,
  },
  {
    deanery: "Udupi Deanery",
    name: "Siyana Martis",
    designation: "YCS President",
    place: "Manipal",
    img: "/images/ycsDexco/siyana.png",
    organization: "YCS",
    rank: 3,
  },
  {
    deanery: "Kallianpur Deanery",
    name: "Rev. Fr Sunil Dsilva",
    designation: "ICYM Director",
    img: "/images/directors/kallianpur_icym_director.jpeg",
    organization: "ICYM",
    rank: 1,
  },
  {
    deanery: "Kallianpur Deanery",
    name: "Rev. Fr Rohan Mascarenhas",
    designation: "YCS Director",
    img: "/images/directors/kallianpur_ycs.jpeg",
    organization: "YCS",
    rank: 2,
  },
  {
    deanery: "Kallianpur Deanery",
    name: "Roshel Dsouza",
    designation: "ICYM President",
    place: "Pethri",
    img: "/images/dexco/roshel.png",
    organization: "ICYM",
    rank: 3,
  },
  {
    deanery: "Kallianpur Deanery",
    name: "Diyona Fernandes",
    designation: "YCS President",
    place: "Thottam",
    img: "/images/ycsDexco/diyona.jpeg",
    organization: "YCS",
    rank: 4,
  },
  {
    deanery: "Shirva Deanery",
    name: "Rev. Fr Kiran Nazareth",
    designation: "ICYM Director",
    img: "/images/directors/icym_shirva.jpeg",
    organization: "ICYM",
    rank: 1,
  },
  {
    deanery: "Shirva Deanery",
    name: "Rev. Fr Oswald Vaz",
    designation: "YCS Director",
    img: "/images/directors/shirva_ycs.jpeg",
    organization: "YCS",
    rank: 2,
  },
  {
    deanery: "Shirva Deanery",
    name: "Delson Furtado",
    designation: "ICYM President",
    place: "Shirva",
    img: "/images/dexco/delson.jpeg",
    organization: "ICYM",
    rank: 3,
  },
  {
    deanery: "Shirva Deanery",
    name: "Joswin Aranha",
    designation: "YCS President",
    place: "Pernal",
    img: "/images/ycsDexco/joswin.jpeg",
    organization: "YCS",
    rank: 4,
  },
];

const defaultRankLookup = new Map(
  defaultDeaneryMembers.map((member, index) => [
    `${member.deanery}::${member.name}::${member.designation}`,
    member.rank || index + 1,
  ]),
);

function inferDeaneryMemberRank(member: Partial<DeaneryMember>) {
  if (typeof member.rank === "number" && Number.isFinite(member.rank) && member.rank > 0) {
    return member.rank;
  }

  const matchedDefaultRank = defaultRankLookup.get(
    `${member.deanery || ""}::${member.name || ""}::${member.designation || ""}`,
  );

  if (matchedDefaultRank) {
    return matchedDefaultRank;
  }

  const designation = (member.designation || "").toLowerCase();

  if (designation.includes("director")) {
    return designation.includes("ycs") && !designation.includes("icym") ? 2 : 1;
  }

  if (designation.includes("president")) {
    return designation.includes("ycs") && !designation.includes("icym") ? 4 : 3;
  }

  return 999;
}

export function normalizeDeaneryMember(
  member: Omit<DeaneryMember, "rank"> & Partial<Pick<DeaneryMember, "rank">>,
): DeaneryMember {
  const inferredDesignationType =
    member.designationType ||
    ((member.designation || "").toLowerCase().includes("director")
      ? "Director"
      : (member.designation || "").toLowerCase().includes("president")
        ? "President"
        : "Others");
  const inferredDesignationDetail =
    inferredDesignationType === "Others" ? member.designation || member.designationDetail || "" : "";

  return {
    ...member,
    designationType: inferredDesignationType,
    designationDetail: inferredDesignationDetail,
    rank: inferDeaneryMemberRank(member),
  };
}

export function sortDeaneryMembers(members: DeaneryMember[]) {
  return [...members].sort((memberA, memberB) => {
    const deaneryIndexDifference =
      DEANERY_OPTIONS.indexOf(memberA.deanery) - DEANERY_OPTIONS.indexOf(memberB.deanery);

    if (deaneryIndexDifference !== 0) {
      return deaneryIndexDifference;
    }

    const designationPriorityDifference =
      getDeaneryDesignationPriority(memberA) - getDeaneryDesignationPriority(memberB);

    if (designationPriorityDifference !== 0) {
      return designationPriorityDifference;
    }

    if (memberA.rank !== memberB.rank) {
      return memberA.rank - memberB.rank;
    }

    const designationComparison = memberA.designation.localeCompare(memberB.designation);

    if (designationComparison !== 0) {
      return designationComparison;
    }

    return memberA.name.localeCompare(memberB.name);
  });
}
